export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-primary-600 to-primary-700 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-3">
              投稿爆料
            </h2>
            <p className="text-primary-100 text-sm md:text-base leading-relaxed max-w-lg">
              手握独家黑料？拍到现场猛料？17吃瓜网开放全网投稿通道，你的爆料可能就是下一个全网热搜。保护投稿人隐私，严格匿名处理，欢迎随时联系我们。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <a
              href="mailto:tougao@17chigua.com"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-background-50 hover:bg-background-100 text-primary-700 font-medium px-6 py-3 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-lg"></i>
              邮件投稿
            </a>
            <a
              href="#comments"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-primary-300/40 hover:border-primary-200 text-background-50 font-medium px-6 py-3 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-chat-1-line text-lg"></i>
              在线留言
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}